// removed by extract-text-webpack-plugin
module.exports = {"wrapper-text-align":"magazines_1WwFt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/editors/FontAlign/styles.scss
// module id = 1118
// module chunks = 1